import { render, staticRenderFns } from "./composantDetailsNumero.vue?vue&type=template&id=7548b84f&scoped=true"
import script from "./composantDetailsNumero.vue?vue&type=script&lang=js"
export * from "./composantDetailsNumero.vue?vue&type=script&lang=js"
import style0 from "./composantDetailsNumero.vue?vue&type=style&index=0&id=7548b84f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7548b84f",
  null
  
)

export default component.exports